export function CreateBatch(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders/batch`;
}

export function Delete(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders`;
}

export function ExportItemizedOrders(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders/export-itemized`;
}

export function ExportOrders(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders/export`;
}

export function ExportTransactions(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders/export-transactions`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders`;
}

export function InitiateFritidskortetCheckout(organizationID: number, orderID: number): string {
	return `/v1/organizations/${organizationID}/orders/${orderID}/fritidskortet/initiate`;
}

export function ListAccountAndWardsOrders(): string {
	return `/v1/accounts/self/orders`;
}

export function ListUserAndWardsOrders(organizationID: number): string {
	return `/v1/organizations/${organizationID}/users/self/orders`;
}

export function MarkPaid(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders/mark-paid`;
}

export function MarkUncollectible(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders/mark-uncollectible`;
}

export function MarkVoid(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders/void`;
}

export function Refund(organizationID: number, orderID: number): string {
	return `/v1/organizations/${organizationID}/orders/${orderID}/refund`;
}

export function RefundFritidskortet(organizationID: number, orderID: number): string {
	return `/v1/organizations/${organizationID}/orders/${orderID}/fritidskortet/refund`;
}

export function ResolveFritidskortetCheckout(organizationID: number, orderID: number): string {
	return `/v1/organizations/${organizationID}/orders/${orderID}/fritidskortet/resolve`;
}

export function SendInvoice(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders/send`;
}

export function SendReceipt(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders/send-receipt`;
}

export function SendReminder(organizationID: number): string {
	return `/v1/organizations/${organizationID}/orders/send-reminder`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/orders/${ID}`;
}

export function UpdateProductRecipient(organizationID: number, orderID: number): string {
	return `/v1/organizations/${organizationID}/orders/${orderID}/update-product-recipient`;
}

